import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { blue_600, red_600, green_600 } from '@fiverr-private/sass/helpers/index';
import { CheckSolidIcon, ExclamationSolidIcon, InfoSolidIcon, SystemIconType } from '@fiverr-private/icons';
import { CloseButton } from '@fiverr-private/button';
import { ToastProps, ToastType } from '../types';
import classes from './index.module.scss';

const ICON_BY_TYPE: { [K in ToastType]: { icon: FC<SystemIconType>; color: string } } = {
  success: { icon: CheckSolidIcon, color: green_600 },
  error: { icon: ExclamationSolidIcon, color: red_600 },
  info: { icon: InfoSolidIcon, color: blue_600 },
};

const Toast = ({ message, type = 'info' }: ToastProps) => {
  const [shouldRender, setShouldRender] = useState(true);

  if (!shouldRender) {
    return null;
  }

  const { icon: Icon, color } = ICON_BY_TYPE[type];

  const wrapperClasses = classNames(classes.toast, 'box-shadow-z4');

  return (
    <span className={wrapperClasses} style={{ borderColor: color }}>
      <div className={classes.statusMessage}>
        <span className={classes.statusIcon}>
          <Icon size={16} color={color} />
        </span>
        <p>{message}</p>
      </div>
      <CloseButton size="xs" onClick={() => setShouldRender(false)} />
    </span>
  );
};

Toast.displayName = 'Toast';

export default Toast;
